module.exports = __webpack_public_path__ + "static-m/img/empty.67403a0f.png";